var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProSide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 51,
    viewBox: "0 0 54 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "PRO-side 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Stroke",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 47.58C36.1944 47.58 45.08 38.6944 45.08 26.5C45.08 14.3055 36.1944 5.42 24 5.42C11.8055 5.42 2.92 14.3055 2.92 26.5C2.92 38.6944 11.8055 47.58 24 47.58ZM24 49.5C37.2548 49.5 47 39.7548 47 26.5C47 13.2452 37.2548 3.5 24 3.5C10.7451 3.5 1 13.2452 1 26.5C1 39.7548 10.7451 49.5 24 49.5Z",
    fill: "url(#paint0_linear_3756_2542)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 1431"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.0648 8.04708C37.9554 8.39557 37.6419 8.63151 37.2879 8.63151H32.5724C31.7811 8.63151 31.4521 9.67993 32.0923 10.1615L35.9073 13.0317C36.1936 13.2471 36.3134 13.6288 36.204 13.9773L34.7468 18.6213C34.5023 19.4005 35.3636 20.0485 36.0038 19.5669L39.8187 16.6968C40.105 16.4815 40.4926 16.4815 40.7789 16.6968L44.594 19.5669C45.2341 20.0485 46.0954 19.4005 45.8509 18.6213L44.3937 13.9773C44.2844 13.6288 44.4041 13.2471 44.6904 13.0317L48.5054 10.1615C49.1456 9.67993 48.8165 8.63151 48.0253 8.63151H43.3097C42.9559 8.63151 42.6422 8.39557 42.5328 8.04708L41.0757 3.40313C40.8312 2.62388 39.7666 2.62387 39.522 3.40313L38.0648 8.04708ZM44.4967 6.09407L43.4063 2.61902C42.4282 -0.497993 38.1696 -0.49802 37.1915 2.61902L36.1011 6.09407L32.5724 6.09408C29.4073 6.09408 28.0913 10.2879 30.6519 12.2144L33.5066 14.3621L32.4162 17.8372C31.4382 20.9542 34.8835 23.5462 37.4441 21.6197L40.2989 19.4721L43.1536 21.6197C45.7142 23.5461 49.1595 20.9542 48.1814 17.8372L47.091 14.3621L49.9457 12.2144C52.5064 10.2879 51.1904 6.09408 48.0253 6.09408L44.4967 6.09407Z",
    fill: "#1C2A34"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M39.5269 3.40329C39.7713 2.62403 40.836 2.62404 41.0806 3.40329L42.5378 8.04724C42.6472 8.39573 42.9608 8.63168 43.3147 8.63168H48.0302C48.8214 8.63168 49.1505 9.6801 48.5103 10.1617L44.6953 13.0318C44.409 13.2473 44.2893 13.629 44.3987 13.9775L45.8557 18.6215C46.1003 19.4007 45.239 20.0487 44.5989 19.5671L40.7839 16.697C40.4976 16.4815 40.11 16.4815 39.8237 16.697L36.0087 19.5671C35.3685 20.0487 34.5071 19.4007 34.7516 18.6215L36.209 13.9775C36.3182 13.629 36.1984 13.2473 35.9121 13.0318L32.0971 10.1617C31.457 9.6801 31.786 8.63168 32.5773 8.63168H37.2929C37.6467 8.63168 37.9603 8.39573 38.0697 8.04724L39.5269 3.40329Z",
    fill: "url(#paint1_linear_3756_2542)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.4436 4.94284C40.6851 5.02579 40.8159 5.29573 40.7359 5.54579L39.3072 10.0053C39.2447 10.2004 39.0685 10.3321 38.8699 10.3321H34.102C33.8476 10.3321 33.6413 10.1186 33.6413 9.85505C33.6413 9.59164 33.8476 9.37806 34.102 9.37806H38.5374L39.8613 5.24543C39.9414 4.99537 40.2021 4.8599 40.4436 4.94284Z",
    fill: "#F7FCFD",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.3483 14.6123C37.5894 14.6968 37.7185 14.9676 37.6369 15.2172L36.8456 17.6354C36.7639 17.8849 36.5024 18.0186 36.2613 17.9341C36.0204 17.8496 35.8912 17.5787 35.9728 17.3292L36.7641 14.911C36.8459 14.6614 37.1074 14.5277 37.3483 14.6123Z",
    fill: "#F7FCFD",
    fillOpacity: 0.8
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3756_2542",
    x1: 48,
    y1: 52.2566,
    x2: -9.53427e-7,
    y2: 2.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#43A1C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4DBD94"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3756_2542",
    x1: 52.2786,
    y1: 17.9184,
    x2: 28.3277,
    y2: 1.23596,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#43A1C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4DBD94"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProSide);
export default __webpack_public_path__ + "static/media/PRO-side.d2ae22cb45365ce3e6ca723c259d33b1.svg";
export { ForwardRef as ReactComponent };